import { Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";
import { Component, CSSProperties } from "react";

import DeliverooActionCreator from "../../controller/action/DeliverooActionCreator";
import DeliverooStore from "../../controller/store/DeliverooStore";

import deliverooLogo from "../../assets/images/IconDeliveroo.png";
import Service from "../../controller/model/service/Service";
import LoadingComponent from "../utils/LoadingComponent";

interface StateInterface {
  service: Service;
  isReady: boolean;
  showError: boolean;
  message: string | undefined;
}

const _updateState = () => {
  const serviceUser = DeliverooStore.service;
  return {
    serviceUser: serviceUser,
  };
};

class DeliverooContainer extends Component {
  public props: any;
  public state: StateInterface;
  private locationId: string | undefined;

  constructor(props: any) {
    super(props);
    this.state = {
      service: DeliverooStore.service,
      isReady: false,
      showError: false,
      message: undefined,
    };
    this.locationId = undefined;
    this._handleStateChange = this._handleStateChange.bind(this);
    this._handleTapConnectButton = this._handleTapConnectButton.bind(this);
    this._handleLocationTextfieldChange = this._handleLocationTextfieldChange.bind(
      this
    );
    this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this);
  }

  componentDidMount() {
    DeliverooStore.addChangeListener(this._handleStateChange);
    DeliverooActionCreator.loadDeliverooServiceUser()
      .then(() => {
        this.setState({ isReady: true });
      })
      .catch((err: any) => {
        console.warn(err);
        this.setState({
          showError: true,
          message: "Error lors de la récupération des infos Deliveroo",
        });
      });
  }

  componentWillUnmount() {
    DeliverooStore.removeChangeListener(this._handleStateChange);
  }

  _handleStateChange() {
    this.setState(_updateState());
  }

  _handleLocationTextfieldChange(e: any) {
    this.locationId = e.target.value;
  }

  _handleTapConnectButton() {
    if (this.locationId !== undefined) {
      DeliverooActionCreator.connectDeliverooServiceUser(
        this.locationId,
        ""
      ).catch((err) => {
        console.warn(err);
        this.setState({
          showError: true,
          message: "Erreur de connexion, veuillez vérifier le location Id",
        });
      });
    }
  }

  _handleTapDisconnectButton() {
    DeliverooActionCreator.disconnectDeliverooService().catch((err: any) => {
      console.warn(err);
      this.setState({
        showError: true,
        message: "Erreur lors de la déconnexion, veuillez réessayer",
      });
    });
  }

  _handleCloseSnackBar() {
    this.setState({ showError: false, message: "" });
  }

  render() {
    return (
      <div style={rootStyle}>
        <Snackbar
          open={this.state.showError}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <MuiAlert severity="error" onClose={this._handleCloseSnackBar}>
            {this.state.message}
          </MuiAlert>
        </Snackbar>
        {true === this.state.isReady ? (
          false === this.state.service.actived ? (
            <div className="deliveroo" style={rootStyle}>
              <div
                className="deliveroo_image"
                style={{ marginTop: "60px", width: "100%" }}
              >
                <img src={deliverooLogo} style={imgStyle()} alt="deliveroo" />
                {/* <div style={{ marginTop: "10px", padding: "20px" }}>
                  <div className="login-box" style={loginBoxStyle()}>
                    <TextField
                      InputProps={{ style: { fontSize: 22 } }}
                      InputLabelProps={{
                        style: {
                          color: "#474F5E",
                        },
                      }}
                      label="Location Id"
                      fullWidth={true}
                      onChange={this._handleLocationTextfieldChange}
                      variant="outlined"
                    />
                    <div style={{ marginTop: "40px", textAlign: "right" }}>
                      <Button
                        color="secondary"
                        style={{ color: "white" }}
                        variant="contained"
                        onClick={this._handleTapConnectButton}
                      >
                        Connexion
                      </Button>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          ) : (
            <div style={rootStyle}>
              <div
                className="deliveroo_image"
                style={{ marginTop: "60px", width: "100%" }}
              >
                <img src={deliverooLogo} style={imgStyle()} alt="deliveroo" />

                <h3 style={{ color: "#474F5E", padding: "25px" }}>
                  Vous êtes actuellement connecté à Deliveroo avec l'id{" "}
                  {this.state.service.locationId}
                </h3>

                <div>
                  <Button
                    color="secondary"
                    style={{ color: "white" }}
                    variant="contained"
                    onClick={this._handleTapDisconnectButton}
                  >
                    Déconnexion
                  </Button>
                </div>
              </div>
            </div>
          )
        ) : (
          <div style={rootStyle}>
            <LoadingComponent isOpen={this.state.isReady} />
          </div>
        )}
      </div>
    );
  }
}

const rootStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  textAlign: "center",
};

// const loginBoxStyle = (): CSSProperties => {
//   return {
//     width: "50%",

//     display: "inline-block",
//   };
// };

const imgStyle = (): CSSProperties => {
  return {
    width: "200px",
    margin: "auto",
  };
};

export default DeliverooContainer;
